import Vue, { VueConstructor } from "vue";
import VueTippy, { TippyComponent } from "vue-tippy";

require('../assets/styles/themes/default.scss');

/*common styles*/
import "../assets/styles/index.scss";
import "@abaco/abc-icons";
import "@fortawesome/fontawesome-pro/css/all.css";
import "animate.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueVirtualScroller from 'vue-virtual-scroller';

import { I18N, i18n } from './i18n';

import { resize } from "./directives/resize";
import { AbcClickOutside } from "./directives/AbcClickOutside";
import { AbcTooltip } from './directives/AbcTooltip';
import { AbcPopover } from './directives/AbcPopover';
import { Highlight } from "./directives/Highlight";

import {AbcMaskDirective} from "./directives/AbcMask";
import {AbcMaskFilter} from "./filters/AbcMask";
import {AbcNumericFilter} from "./filters/NumericFilter";

import { Fragment } from 'vue-frag'
Vue.component('Fragment', Fragment);

// https://kabbouchi.github.io/tippyjs-v4-docs/all-options/
Vue.use(VueTippy, {
    directive: "tippy", // => v-tippy
    component: 'tippy', // => <tippy/>
    flipDuration: 0,
    allowHTML: true,
    distance: 10,
    duration: [200, 0],
    delay: [0, 0],
    arrow: false,
    animateFill: false,
    animation: "shift-toward",
    popperOptions: {
        modifiers: {
            preventOverflow: {
                enabled: false,
            },
        },
    },
});
Vue.component("tippy", TippyComponent);
Vue.use(VueVirtualScroller)

function install(vue: VueConstructor<Vue>, options: any) {
    vue.component("AbcAccordion", () => import("./accordion/AbcAccordion.vue"));
    vue.component("AbcAlert", () => import("./alert/AbcAlert.vue"));
    vue.component("AbcNoDataFound", () => import("./alert/AbcNoDataFound.vue"));
    vue.component("AbcRefineFilter", () => import("./alert/AbcRefineFilter.vue"));
    vue.component("AbcButton", () => import("./button/AbcButton.vue"));
    vue.component("AbcFormButtons", () => import("./button/AbcFormButtons.vue"));
    vue.component("AbcToolButton", () => import("./button/AbcToolButton.vue"));
    vue.component("AbcCalendar", () => import("./calendar/AbcCalendar.vue"));
    vue.component("AbcDayYearTooltip", () => import("./calendar/AbcDayYearTooltip.vue"));
    vue.component("AbcCardBox", () => import("./card/AbcCardBox.vue"));
    vue.component("AbcSelectableCard", () => import("./card/AbcSelectableCard.vue"));
    vue.component("AbcCarousel", () => import("./carousel/AbcCarousel.vue"));
    vue.component("AbcDatePicker", () => import("./date-picker/AbcDatePicker.vue"));
    vue.component("AbcDateTimePicker", () => import("./date-picker/AbcDateTimePicker.vue"));
    vue.component("AbcMonthPicker", () => import("./date-picker/AbcMonthPicker.vue"));
    vue.component("AbcYearPicker", () => import("./date-picker/AbcYearPicker.vue"));
    vue.component("AbcTimePicker", () => import("./date-picker/AbcTimePicker.vue"));
    vue.component("AbcDropdown", () => import("./dropdown/AbcDropdown.vue"));
    vue.component("AbcDropdown2", () => import("./dropdown/AbcDropdown2.vue"));
    vue.component("AbcForm", () => import("./form/AbcForm.vue"));
    vue.component("AbcInfiniteSupport", () => import("./inifinite/AbcInfiniteSupport.vue"));
    vue.component("AbcInfiniteAutocomplete", () => import("./inifinite/AbcInfiniteAutocomplete.vue"));
    vue.component("AbcAutocomplete", () => import("./input/AbcAutocomplete.vue"));
    vue.component("AbcCheckbox", () => import("./input/AbcCheckbox.vue"));
    vue.component("AbcRadio", () => import("./input/AbcRadio.vue"));
    vue.component("AbcSwitch", () => import("./input/AbcSwitch.vue"));
    vue.component("AbcDateInput", () => import("./input/AbcDateInput.vue"));
    vue.component("AbcInput", () => import("./input/AbcInput.vue"));
    vue.component("AbcFileInput", () => import("./input/AbcFileInput.vue"));
    vue.component("AbcFileInputDragAndDrop", () => import("./input/AbcFileInputDragAndDrop.vue"));
    vue.component("AbcSlider", () => import("./input/AbcSlider.vue"));
    vue.component("AbcSelect", () => import("./input/AbcSelect.vue"));
    vue.component("AbcTextarea", () => import("./input/AbcTextarea.vue"));
    vue.component("AbcLoader", () => import("./loader/AbcLoader.vue"));
    vue.component("AbcProgressBar", () => import("./loader/AbcProgressBar.vue"));
    vue.component("AbcGroupedList", () => import("./list/AbcGroupedList.vue"));
    vue.component("AbcList", () => import("./list/AbcList.vue"));
    vue.component("AbcVirtualList", () => import("./list/AbcVirtualList.vue"));
    vue.component("AbcNavBarItem", () => import("./navbar/AbcNavBarItem.vue"));
    vue.component("AbcNavBarItemPanel", () => import("./navbar/AbcNavBarItemPanel.vue"));
    vue.component("AbcTreeView", () => import("./treeView/AbcTreeView.vue"));
    vue.component("AbcLinkList", () => import("./list/AbcLinkList.vue"));
    vue.component("AbcModal", () => import("./modal/AbcModal.vue"));
    vue.component("AbcPagination", () => import("./pagination/AbcPagination.vue"));
    vue.component("AbcSection", () => import("./section/AbcSection.vue"));
    vue.component("AbcStep", () => import("./stepper/AbcStep.vue"));
    vue.component("AbcStepper", () => import("./stepper/AbcStepper.vue"));
    vue.component("AbcStepButtons", () => import("./stepper/AbcStepButtons.vue"));
    vue.component("AbcTab", () => import("./tab/AbcTab.vue"));
    vue.component("AbcTabs", () => import("./tab/AbcTabs.vue"));
    vue.component("AbcTable", () => import("./table/AbcTable.vue"));
    vue.component("AbcVirtualTable", () => import("./table/AbcVirtualTable.vue"));
    vue.component("AbcTag", () => import("./tag/AbcTag.vue"));
    vue.component("AbcTopTileButton", () => import("./tile/AbcTopTileButton.vue"));
    vue.component("AbcTopTileToggle", () => import("./tile/AbcTopTileToggle.vue"));
    vue.component("AbcTopTileChartViewToggle", () => import("./tile/AbcTopTileChartViewToggle.vue"));
    vue.component("AbcPopover", () => import("./popover/AbcPopover.vue"));
    vue.component("AbcDraggable", () => import("vuedraggable"));
    vue.directive("resize", resize);
    vue.directive('abc-click-outside', AbcClickOutside);
    vue.directive("abc-tooltip", AbcTooltip);
    vue.directive("abc-popover", AbcPopover);
    vue.directive("abc-highlight", Highlight);
    vue.directive("abc-mask", AbcMaskDirective());
    vue.filter("AbcMask", AbcMaskFilter());
    vue.filter("AbcNumericMask", AbcNumericFilter);
}

export function setI18N(val: Partial<I18N>) {
    val.locale = val.locale?.replace("_", "-");
    Object.assign(i18n, val);
}

export default { install };

